export const SUPPORT_EMAIL = 'sdev@ftlovolleyball.ca';

export const LEAGUES_EMAIL = 'leagues@ftlovolleyball.ca';

export const TOURNAMENTS_EMAIL = 'tournaments@ftlovolleyball.ca';

export const DROPIN_EMAIL = 'dropin@ftlovolleyball.ca';

export const SENDER_NAME = 'FTLO Volleyball';

export function normalizePhone(raw: string): string | null {
  const digits = raw.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  if (digits.length !== 10) return null;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
}

export const PHONE_ERROR = 'Please enter a 10-digit phone number.';
